"use client";

import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { sans as zoram, fontSize14, lineHeightTight, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
export const internalUseOnlyPriority5 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightBold, fontSize14, lineHeightTight);
const H5Styled = styled.h5.withConfig({
  componentId: "sc-1k9r0br-0"
})(["", ";"], internalUseOnlyPriority5);
const H5 = _ref => {
  let {
    children,
    renderAs,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(H5Styled, {
    as: renderAs,
    ...props,
    children: children
  });
};
export default H5;
H5.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired,
  /** The HTML tag string (e.g., `"div"`) or React component to render as. */
  renderAs: PropTypes.elementType
};